import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import cn from 'classnames';

import { ROOT } from 'src/constants/routes';
import { useAppContext } from 'src/context/AppContext';

import { Category, formatEventDateRange } from '../utils';

import css from './Wars.module.scss';

const CATEGORY_CSS = {
  [Category.WAR]: css.w,
  [Category.MILITARY_OPERATION]: css.mo,
  [Category.TERRORIST_OPERATIONS]: css.to,
} as const;

export const Wars = () => {
  const [searchParams] = useSearchParams();
  const birthDateParam = searchParams.get('d');
  const { personalStats } = useAppContext();

  if (!birthDateParam) {
    return <Navigate to={ROOT} />;
  }

  if (!personalStats) {
    return null;
  }

  const today = new Date();
  const { timeline } = personalStats;

  return (
    <section className={css.wars}>
      <div className={css.timeline}>
        <div className={css.line} aria-hidden />
        <ul className={css.list}>
          {timeline.map((event) => (
            <li key={`${event.name}-${event.startDate}`} className={css.item}>
              <span className={cn(css.dot, CATEGORY_CSS[event.category])} aria-hidden />
              <div className={css.content}>
                <p className={css.name}>{event.name}</p>
                <p className={css.dates}>{formatEventDateRange(event, today)}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Wars;
